import React from "react";
import { Outlet } from "react-router-dom";
import PageFooter from "../../Components/Footer";
import PageHeader from "../../Components/Header";
import { useAuth } from "../../contexts/AuthContext";

const Layout = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="main-app-wrapper">
      <PageHeader />
      <Outlet />
      <PageFooter compact={!isAuthenticated} />
    </div>
  );
};

export default Layout;
